var exports = {
  "qd": "xaf9ae18d--fffbb4--layer",
  "Kk": "xaf9ae18d--fffbb4--icon",
  "as": "xaf9ae18d--fffbb4--large",
  "n2": "xaf9ae18d--fffbb4--extra-large",
};

module.exports = exports;
